var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#12BFE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44072 14C6.37982 13.9999 6.3196 13.9871 6.2639 13.9625C6.20821 13.9378 6.15824 13.9019 6.1172 13.8569C6.0754 13.8122 6.04351 13.7593 6.02362 13.7015C6.00372 13.6436 5.99627 13.5823 6.00174 13.5214L6.10929 12.3385L11.0776 7.37054L12.6303 8.92318L7.66327 13.8907L6.48067 13.9982C6.46739 13.9995 6.45406 14.0001 6.44072 14V14ZM12.9402 8.61274L11.388 7.0601L12.319 6.12878C12.3598 6.08796 12.4082 6.05557 12.4615 6.03347C12.5148 6.01137 12.5719 6 12.6296 6C12.6873 6 12.7444 6.01137 12.7977 6.03347C12.851 6.05557 12.8994 6.08796 12.9402 6.12878L13.8713 7.0601C13.9121 7.10088 13.9444 7.14931 13.9665 7.20261C13.9886 7.25592 14 7.31306 14 7.37076C14 7.42846 13.9886 7.4856 13.9665 7.53891C13.9444 7.59221 13.9121 7.64064 13.8713 7.68142L12.9406 8.6123L12.9402 8.61274V8.61274Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/EditPen.aca45824a822176c0aac8f01b1b13526.svg";
export { ForwardRef as ReactComponent };